import { schema } from 'normalizr';
import { userSchema } from './users';

export const salesTargetSchema = new schema.Entity('salesTargets', {
  user: userSchema
});
